import type { Account, Card } from '../../../../generated-types';
import { AccountCardType, GroupedAccountCardItem } from '../../../../models/account';

const mapAccountToAccountCardItem = (account: Account): GroupedAccountCardItem => ({
    alias: account.alias,
    accountNumber: account.accountNumber,
    favorite: account.favorite,
    sortKey: account.sortKey,
    accountType: AccountCardType.ACCOUNT,
    account,
    id: `${account.accountNumber.value}-account`,
});

const mapCardToAccountCardItem = (card: Card): GroupedAccountCardItem => ({
    alias: card.name,
    accountNumber: card.accountNumber,
    favorite: card.favorite,
    sortKey: card.sortKey,
    accountType: AccountCardType.CREDIT_CARD,
    card,
    id: `${card.accountNumber.value}-card`,
});

const sortBySortKey = (a: GroupedAccountCardItem, b: GroupedAccountCardItem) => {
    const aNoSortKey = a.sortKey === undefined || a.sortKey.value === 0;
    const bNoSortKey = b.sortKey === undefined || b.sortKey.value === 0;
    if (aNoSortKey && bNoSortKey) {
        return 0;
    }
    if (aNoSortKey) {
        return 1;
    }
    if (bNoSortKey) {
        return -1;
    }
    return a.sortKey!.value - b.sortKey!.value;
};

const mapAllAccountCardItems = (accounts: Account[] = [], cards: Card[] = []) =>
    [...accounts.map(mapAccountToAccountCardItem), ...cards.map(mapCardToAccountCardItem)].sort(sortBySortKey);

export default mapAllAccountCardItems;
